<h1>{{ title }}</h1>

<div class="parent-container">

  <div class="table-container">
    <mat-table [dataSource]="dataSource">
      <div *ngFor="let column of columns; trackBy: trackByIndex">
        <ng-container [matColumnDef]="column.key">
          <mat-header-cell *matHeaderCellDef [matTooltip]="column.headerTooltip">{{column.header}}</mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element[column.key + 'Tooltip']"
            (click)="countryClicked(element.countryCode)">{{element[column.key]}}
          </mat-cell>
        </ng-container>
      </div>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row mat-row *matRowDef="let row; columns: displayedColumns;" [class.selected-row]="selectedRow === row"
        [ngClass]="isDarkTheme ? 'background-highlight-dark' : 'background-highlight'"></mat-row>
    </mat-table>
  </div>

  <div class="map-container">
    <app-map-expense-calculation [title]="title" [chartDataSource]="chartDataSource" [isDarkTheme]="isDarkTheme"
      (countryClicked)="countryClicked($event)">
    </app-map-expense-calculation>
    <alert *ngIf="disclaimer != null" type="info" class="disclaimer-alert">
      {{ disclaimer }}
    </alert>
  </div>
</div>

